import React, { useState } from 'react';
import {
  Alert,
  AlertTitle,
  Box,
  Collapse,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from '@mui/material';
import {
  ExpandMore as ExpandMoreIcon,
  ExpandLess as ExpandLessIcon,
  Info as InfoIcon
} from '@mui/icons-material';

interface CollapsibleInfoCardProps {
  title: string;
  content: string | React.ReactNode;
  defaultExpanded?: boolean;
}

const CollapsibleInfoCard: React.FC<CollapsibleInfoCardProps> = ({
  title,
  content,
  defaultExpanded = true
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [expanded, setExpanded] = useState(isMobile ? false : defaultExpanded);

  const handleToggle = () => {
    setExpanded(!expanded);
  };

  if (isMobile) {
    return (
      <Alert 
        severity="info" 
        sx={{ 
          mb: 2,
          '& .MuiAlert-message': { width: '100%' }
        }}
        icon={<InfoIcon />}
      >
        <Box sx={{ width: '100%' }}>
          <Box 
            sx={{ 
              display: 'flex', 
              alignItems: 'center', 
              justifyContent: 'space-between',
              cursor: 'pointer',
              userSelect: 'none'
            }}
            onClick={handleToggle}
          >
            <AlertTitle sx={{ mb: expanded ? 1 : 0, fontSize: '0.875rem' }}>
              {title}
            </AlertTitle>
            <IconButton 
              size="small" 
              sx={{ ml: 1 }}
              onClick={(e) => {
                e.stopPropagation();
                handleToggle();
              }}
            >
              {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
            </IconButton>
          </Box>
          <Collapse in={expanded}>
            {typeof content === 'string' ? (
              <Typography variant="body2">
                {content}
              </Typography>
            ) : (
              content
            )}
          </Collapse>
        </Box>
      </Alert>
    );
  }

  // Desktop view - always expanded
  return (
    <Alert severity="info" sx={{ mb: 2 }}>
      {typeof content === 'string' ? (
        <Typography variant="body2">
          {content}
        </Typography>
      ) : (
        content
      )}
    </Alert>
  );
};

export default CollapsibleInfoCard;